import React from 'react';

const Contact = () => {
    return ( 
        <div className='contact' name='contact'>
            <div className='form'>
                <h1 data-aos="fade-right">I’m ready to talk...</h1>
                <form action='' >
                       <div className='inps_for_sending' data-aos="zoom-in-up" data-aos-delay='200'>
                            <input type='text' name='name' id='name' required autoComplete='false' /> 
                            <label for='name'>Name</label>
                       </div>
                       <div className='inps_for_sending' data-aos="zoom-in-up" data-aos-delay='200'>
                            <input type='email' name='email' id='email' required autoComplete='false' /> 
                            <label for='email'>Email</label>
                       </div>
                       <div className='inps_for_sending' data-aos="zoom-in-up" data-aos-delay='200'>
                            <textarea name='message' id='message' rows={5} required autoComplete='false' /> 
                            <label for='message'>Message</label>
                       </div>
                        <div className='btn_form_contact' data-aos="zoom-in-left" data-aos-delay='200'>
                            <button>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
                                    <path d="M0.00999999 18L21 9L0.00999999 0L0 7L15 9L0 11L0.00999999 18Z" fill="#211B12"/>
                                </svg>
                                Send
                            </button>
                        </div>
                </form>
            </div>
        </div>
     );
}
 
export default Contact;